import React from "react";
import { Link } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import "../css/about.scss";

function About() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div className="about">
      <Header />

      <main className="about__main">
        {/* 面包屑导航 */}
        <div className="breadcrumb">
          <div className="breadcrumb__container">
            <Link to="/" onClick={toTop}>
              HOME
            </Link>
            <span className="breadcrumb__separator">»</span>
            <span className="breadcrumb__current">ABOUT Emeline</span>
          </div>
        </div>

        <div className="about__container">
          <div className="about__content">
            {/* 页面标题 */}
            <section className="about__hero">
              <h1 className="about__title">ABOUT Emeline PUBLICATIONS</h1>
              <p className="about__subtitle">
                Australia's Leading Automotive Book Publisher
              </p>
            </section>

            {/* 公司介绍 */}
            <section className="about__section">
              <h2 className="section__title">Our Story</h2>
              <div className="section__content">
                <p className="section__text">
                  Emeline Publications has been Australia's premier publisher of
                  automotive repair manuals, service guides, and technical
                  literature for over four decades. Based in Sydney, we have
                  built our reputation on providing comprehensive, accurate, and
                  easy-to-follow automotive information for both professional
                  mechanics and DIY enthusiasts.
                </p>
                <p className="section__text">
                  Our commitment to quality and detail has made us the trusted
                  choice for automotive professionals across Australia and
                  internationally. We specialize in creating detailed repair
                  manuals that cover everything from routine maintenance to
                  complex engine rebuilds.
                </p>
              </div>
            </section>

            {/* 我们的使命 */}
            <section className="about__section">
              <h2 className="section__title">Our Mission</h2>
              <div className="section__content">
                <p className="section__text">
                  To provide the most comprehensive and reliable automotive
                  technical information available, empowering mechanics,
                  technicians, and automotive enthusiasts with the knowledge
                  they need to maintain, repair, and restore vehicles to the
                  highest standards.
                </p>
                <p className="section__text">
                  We believe that access to quality technical information is
                  essential for safe and effective vehicle maintenance, and we
                  are committed to making this information accessible to
                  everyone.
                </p>
              </div>
            </section>

            {/* 我们的专业领域 */}
            <section className="about__section">
              <h2 className="section__title">Our Expertise</h2>
              <div className="section__content">
                <div className="expertise__grid">
                  <div className="expertise__item">
                    <h3 className="expertise__title">
                      Automotive Repair Manuals
                    </h3>
                    <p className="expertise__text">
                      Comprehensive step-by-step repair procedures for all major
                      vehicle systems, including engine, transmission, brakes,
                      and electrical systems.
                    </p>
                  </div>
                  <div className="expertise__item">
                    <h3 className="expertise__title">Service Manuals</h3>
                    <p className="expertise__text">
                      Detailed maintenance schedules, specifications, and
                      service procedures to keep vehicles running at peak
                      performance.
                    </p>
                  </div>
                  <div className="expertise__item">
                    <h3 className="expertise__title">Wiring Diagrams</h3>
                    <p className="expertise__text">
                      Accurate electrical system diagrams and troubleshooting
                      guides for complex automotive electrical systems.
                    </p>
                  </div>
                  <div className="expertise__item">
                    <h3 className="expertise__title">
                      Technical Specifications
                    </h3>
                    <p className="expertise__text">
                      Precise torque specifications, fluid capacities, and
                      technical data essential for professional automotive work.
                    </p>
                  </div>
                </div>
              </div>
            </section>

            {/* 质量承诺 */}
            <section className="about__section">
              <h2 className="section__title">Quality Commitment</h2>
              <div className="section__content">
                <p className="section__text">
                  Every Emeline Publications manual is created through
                  meticulous research and hands-on experience. Our team of
                  automotive experts and technical writers work directly with
                  vehicles, dismantling and rebuilding systems to ensure every
                  procedure is accurate and complete.
                </p>
                <p className="section__text">
                  We maintain the highest standards of technical accuracy and
                  clarity, with all publications reviewed by certified
                  automotive technicians before publication. Our commitment to
                  quality has earned us the trust of automotive professionals
                  worldwide.
                </p>
              </div>
            </section>

            {/* 联系信息 */}
            <section className="about__section about__section--contact">
              <h2 className="section__title">Get In Touch</h2>
              <div className="section__content">
                <p className="section__text">
                  Have questions about our publications or need technical
                  support? Our knowledgeable team is here to help.
                </p>
                <div className="contact__info">
                  <div className="contact__item">
                    <strong>Business Hours:</strong>
                    <p>Monday - Friday: 9:30am to 4:00pm</p>
                    <p>Saturday, Sunday & Public Holidays: Closed</p>
                  </div>
                  <div className="contact__item">
                    <strong>Location:</strong>
                    <p>6107 Katherine Rd, Rex, Georgia 30273, United States</p>
                  </div>
                </div>
                <div className="contact__actions">
                  <Link to="/contact" onClick={toTop} className="contact__btn">
                    Contact Us
                  </Link>
                  <Link to="/shop" onClick={toTop} className="shop__btn">
                    Browse Our Publications
                  </Link>
                </div>
              </div>
            </section>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}

export default About;
